export enum ConfigurationType {
  MinimumWages = 0,
  Violation = 1,
  BusinessTrip = 2,
  BusinessTripRates = 3,
  Timesheet = 4,
  TimesheetAdditional = 5,
}
